"use client"

import { useCallback, useEffect, useState, MouseEvent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LButton from "./LButton";
import LuminodeLogo from "./LuminodeLogo";
import Luminode from "./svg/LuminodeLogo";
import NavBarSpicy from "./svg/NavBarSpicy";

export const HEADER_SIZE = 95;

function getCurrentSection(reflist: any[]) {
  let CRL = reflist.map((x: any) => {
    return x.current?.getBoundingClientRect();
  });
  for (let i = CRL.length - 1; i > -1; i--) {
    if (CRL[i]?.top < (HEADER_SIZE + 1)) {
      return i;
    }
  }
  return 0;
}

// Hover: fade to white and draw a thin brand-blue rule in from the left.
const NAV_LINK_CLASSES =
  "relative transition-colors duration-300 hover:text-white " +
  "after:absolute after:left-0 after:-bottom-[6px] after:h-px after:w-full after:bg-luminode-blue " +
  "after:origin-left after:scale-x-0 after:transition-transform after:duration-300 " +
  "after:ease-[cubic-bezier(0.22,1,0.36,1)] hover:after:scale-x-100";

function NewHeader({ reflist , fixed}: any) {
  let [currentSection, setCurrentSection] = useState(getCurrentSection(reflist));
  let [scrollY, setScrollY] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = () => {
    setCurrentSection(getCurrentSection(reflist));
    setScrollY(window.scrollY);
  }
  function scrollIntoView(i: number, reflist: any[]) {
    if (reflist[i]?.current) {
      let to = window.scrollY + reflist[i].current?.getBoundingClientRect()?.top - HEADER_SIZE;
      window.scrollTo({ top: to, behavior: "smooth" });
    } else {
      // Pages other than home (e.g. /portfolio) don't have these sections, so
      // go home and let the home page's header scroll to the one requested.
      navigate("/", { state: { section: i } });
    }
  }
  useEffect(() => {
    const section = location.state?.section;
    if (typeof section === "number" && reflist[section]?.current) {
      scrollIntoView(section, reflist);
    }
  }, [location]);
  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    return (() => {
      document.removeEventListener("scroll", handleScroll);
    })
  })
  useEffect(() => {
    setCurrentSection(getCurrentSection(reflist));
  }, [reflist]);
  const generateClickHandler = function (idx: number) {
    return function (e: MouseEvent<HTMLAnchorElement>) {
      e.preventDefault();
      scrollIntoView(idx, reflist);
    }
  }
  return (
    <div id="app-header" className={`w-full px-4 pt-[40px] pb-[40px] flex flex-row items-center justify-between font-geist-mono font-normal sticky top-0 ${scrollY === 0 ? 'bg-transparent' : 'bg-[#090910]'} z-[50] transition-all ease-in-out duration-500`}>
      <LuminodeLogo />
      <div className="hidden relative lg:flex flex-row text-white text-[14px] items-center gap-[48px] font-light z-[80]">
        <a href='#' onClick={generateClickHandler(0)} className={`${NAV_LINK_CLASSES} ${currentSection === 0 ? `text-white` : `text-faded`}`}>Home</a>
        <a href='#' onClick={generateClickHandler(1)} className={`${NAV_LINK_CLASSES} ${currentSection === 1 ? `text-white` : `text-faded`}`}>Expertise</a>
        <a href='#' onClick={generateClickHandler(2)} className={`${NAV_LINK_CLASSES} ${currentSection === 2 ? `text-white` : `text-faded`}`}>Mission</a>
        <a href='#' onClick={generateClickHandler(3)} className={`${NAV_LINK_CLASSES} ${currentSection === 3 ? `text-white` : `text-faded`}`}>Advantage</a>
        <a href='#' onClick={generateClickHandler(4)} className={`${NAV_LINK_CLASSES} ${currentSection === 4 ? `text-white` : `text-faded`}`}>Contact</a>
        <div className="absolute left-[-46px] top-[-17px] z-10 pointer-events-none">
          <NavBarSpicy />
        </div>
      </div>
      <LButton push_down={true}>
        Contact Us
      </LButton>
    </div>
  );
}

export default NewHeader;